import { render, staticRenderFns } from "./buffetTable.vue?vue&type=template&id=14abadfa&"
import script from "./buffetTable.vue?vue&type=script&lang=js&"
export * from "./buffetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports